<template>
  <c-modal @onClosed="onClosed" :value="true" :persistent="true" width="647">
    <div class="heading-5 font-weight-medium">Connect {{ name }} Wallet</div>
    <div class="mt-8" v-if="owners">
      <div class="p-12-r gray--text">Safe Owners</div>
      <div
        class="d-flex align-center mt-2"
        v-for="owner in owners"
        :key="owner.address"
      >
        <div
          class="p-16-r eth-address"
          :id="`ownerAddress_${owner.address}`"
        >
          {{ owner.address }}
        </div>
      </div>
      <v-divider class="mt-3"></v-divider>
    </div>
    <div class="mt-5">
      <div class="h1-26-m">Select Wallet</div>
      <div class="d-flex align-center justify-space-between mt-3">
        <from-existing-wallet
          @onWalletSelected="onWalletSelected"
          :owners="owners"
        />
        <v-checkbox
          v-model="checkboxExisting"
          :disabled="!walletExisting"
          hide-details
          class="mt-0 ml-3"
          @change="checkboxExisting && (checkboxNew = false)"
        ></v-checkbox>
      </div>
    </div>
    <div class="mt-8">
      <div class="h1-26-m">Or Connect With</div>
      <connect-new-wallet
        @onWalletConnected="onWalletConnected"
        :owners="owners"
      />
      <div class="mt-5">
        <div class="d-flex align-center justify-space-between">
          <div
            class="flex-1 d-flex align-center border-default rounded-50 pl-5"
            style="height:48px;"
          >
            <img v-if="walletNew" :src="walletNew.logo" height="22px" />
            <span v-if="walletNew" class="p-16-r ml-3">{{
              walletNew.address
            }}</span>
            <span v-else class="gray--text p-16-r">No wallet connected.</span>
          </div>
          <v-checkbox
            :disabled="!walletNew"
            v-model="checkboxNew"
            hide-details
            class="mt-0 ml-3"
            @change="checkboxNew && (checkboxExisting = false)"
          ></v-checkbox>
        </div>
        <div
          class="p-14-r error--text ml-2"
          v-if="owners && walletNew && !walletNew.isOwner"
        >
          This wallet is not an owner. Please connect to another wallet.
        </div>
      </div>
    </div>
    <div class="mt-10 d-flex justify-end align-center">
      <div class="p-16-m gray--text clickable" @click="onClosed">Cancel</div>
      <c-btn @click="nextStep" class="ml-5" :disabled="!walletSelected"
        >Continue</c-btn
      >
    </div>
  </c-modal>
</template>

<script>
import FromExistingWallet from "./FromExistingWallet";
import ConnectNewWallet from "./ConnectNewWallet";

export default {
  props: ["owners", "name"],
  components: {
    FromExistingWallet,
    ConnectNewWallet,
  },
  data: () => ({
    checkboxExisting: false,
    checkboxNew: false,
    walletExisting: null,
    walletNew: null,
  }),
  computed: {
    walletSelected() {
      if (this.checkboxExisting) {
        return this.walletExisting;
      }
      if (this.checkboxNew && (!this.owners || this.walletNew?.isOwner)) {
        return { ...this.walletNew, logo: undefined, isOwner: undefined };
      }
    },
  },
  methods: {
    onClosed() {
      this.$emit("onClosed");
    },
    onWalletConnected(data) {
      this.walletNew = data;
      if (this.walletNew.isOwner || !this.owners) {
        this.selectNew();
      }
    },
    onWalletSelected(data) {
      this.walletExisting = data;
      this.selectExisting();
    },
    selectNew() {
      this.checkboxNew = true;
      this.checkboxExisting = false;
    },
    selectExisting() {
      this.checkboxNew = false;
      this.checkboxExisting = true;
    },
    nextStep() {
      if (!this.walletSelected) return;
      this.$emit("onNext", this.walletSelected);
      this.onClosed();
    },
  },
};
</script>
